import { Avatar, Button, TextField } from "@mui/material";
import { DemoComunityListObject } from "assets/data/communities";
import { useEffect, useState } from "react";
import { MyModal } from "ui";
import { CustomComponentProps } from "utils/types/general.types";
import { VisuallyHiddenInput } from "../notifications/AddNotiForm";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { DemoUserListObject } from "assets/data/usersData";

export type MessageCommunityModalProps = CustomComponentProps & {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    group?: DemoComunityListObject;
    user?: DemoUserListObject;
};

const MessageCommunityModal = ({
    open,
    setOpen,
    group,
    user,
    className,
    style
}: MessageCommunityModalProps) => {
    const [title, setTitle] = useState("");
    const [titleError, setTitleError] = useState(false);
    useEffect(() => {
        if (title.length) {
            setTitleError(false);
        }
    }, [title]);

    const [msg, setMsg] = useState("");
    const [msgError, setMsgError] = useState(false);
    useEffect(() => {
        if (msg.length) {
            setMsgError(false);
        }
    }, [msg]);

    const [file, setFile] = useState<string>();
    const handleFileChange = (file: FileList | null) => {
        if (!file) {
            return;
        }
        setFile(URL.createObjectURL(file[0]));
    };

    const clearForm = () => {
        setTitle("");
        setMsg("");
        setFile(undefined);
    };

    useEffect(() => {
        if (!open) {
            clearForm();
        }
    }, [open]);

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!title.length) {
            setTitleError(true);
            return;
        }
        if (!msg.length) {
            setMsgError(true);
            return;
        }

        setOpen(false);
    };

    return (
        <MyModal
            open={open}
            setOpen={setOpen}
            className={className}
            style={style}
        >
            <form
                onSubmit={handleFormSubmit}
                className="w-full flex flex-col gap-3"
            >
                <div className="w-full text-center">
                    <legend className="font-semibold text-lg dark:text-white">
                        Send Message to "
                        {group ? group.title : user && user.name}"
                    </legend>
                </div>

                {/* title */}
                <TextField
                    name="title"
                    label="Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    variant="outlined"
                    className="w-full"
                    error={titleError}
                    helperText={titleError ? "Please Write Title" : ""}
                />
                {/* message */}
                <TextField
                    name="msg"
                    label="Message"
                    placeholder="Your message..."
                    multiline
                    rows={4}
                    value={msg}
                    onChange={(e) => setMsg(e.target.value)}
                    variant="outlined"
                    className="w-full"
                    error={msgError}
                    helperText={msgError ? "Please Write The Message" : ""}
                />
                {/* select media */}
                <div className="flex w-full justify-start gap-10 items-center">
                    <Button
                        component="label"
                        role={undefined}
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<CloudUploadIcon />}
                        style={{ color: "white" }}
                    >
                        Upload file
                        <VisuallyHiddenInput
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleFileChange(e.target.files)}
                        />
                    </Button>

                    {file && (
                        <Avatar
                            alt="Notification media"
                            src={file}
                            sx={{ width: 56, height: 56 }}
                        />
                    )}
                </div>

                <div className="w-full text-center p-5">
                    <button
                        className="px-5 py-2 text-sm text-center bg-momeento-50 text-white hover:shadow-xl rounded-full"
                        type="submit"
                    >
                        Send Message
                    </button>
                </div>
            </form>
        </MyModal>
    );
};

export default MessageCommunityModal;
